import React from 'react';
import cn from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { NexusFlowerIcon } from '@components/Icons/AIFlower';
import Tooltip, { Overlay } from '@components/Tooltip';
import styles from './NexusButton.module.scss';

export default function NexusButton() {
  const location = useLocation();

  return (
    <Tooltip
      popupClassName={styles.aiChatLinkPopup}
      overlay={<Overlay>Nexus</Overlay>}
      placement="right"
      delay
    >
      <Link
        className={cn(
          styles.aiChatLink,
          location.pathname.startsWith('/nexus') && styles.chatLinkActive,
        )}
        to="/nexus"
        id="nexus-btn"
      >
        <NexusFlowerIcon width={20} height={20} strokeWidth={1.8} color="textPrimary" />
      </Link>
    </Tooltip>
  );
}
